var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brb-uploader flex-grow-1" },
    [
      _c(
        "brb-input-group",
        _vm._b(
          {
            attrs: {
              size: _vm.size,
              prepend: _vm.label,
              required: _vm.required,
            },
            scopedSlots: _vm._u(
              [
                !!_vm.$slots.prepend
                  ? {
                      key: "prepend",
                      fn: function () {
                        return [_vm._t("prepend")]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c(
                        "b-btn",
                        {
                          ref: "brb-uploader-browse-button",
                          staticClass:
                            "d-flex align-items-center justify-content-center p-2",
                          class: { "invalid-input": _vm.error },
                          staticStyle: {
                            "border-top-left-radius": "5px",
                            "border-bottom-left-radius": "5px",
                          },
                          attrs: {
                            variant: _vm.uploading ? "secondary" : "success",
                            size: _vm.size,
                            disabled: _vm.inputDisabled,
                            "tab-index": _vm.tabIndex,
                          },
                          on: { click: _vm.browse },
                        },
                        [
                          _vm.uploading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : [
                                _c("font-awesome-icon", {
                                  class: `m${_vm.$dir.rtl ? "l" : "r"}-sm-2`,
                                  attrs: { icon: "cloud-upload-alt" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-block" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("forms.ChooseFile")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          "brb-input-group",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "div",
            { staticClass: "input flex-grow-1 px-2" },
            [
              _vm.files && _vm.files.length
                ? _vm._l(_vm.files, function (file, index) {
                    return _c(
                      "div",
                      {
                        key: file,
                        staticClass:
                          "d-flex flex-grow-1 align-items-center py-1",
                      },
                      [
                        _vm.multiple
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "d-block text-muted font-weight-bold font-lg single-line text-center",
                                staticStyle: { width: "20px" },
                              },
                              [_vm._v(" " + _vm._s(index + 1) + " ")]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "flex-grow-1 mx-2" },
                          [
                            file.match(/\.(jpeg|jpg|gif|png)$/) != null
                              ? _c("brb-image-preview", {
                                  attrs: {
                                    src: file,
                                    width: "40",
                                    height: "40",
                                    "no-thumbnail": "",
                                    circle: "",
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-center border rounded-circle",
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "text-muted",
                                      attrs: { icon: "file", size: "2x" },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-center",
                                attrs: {
                                  href: _vm.$config.files.createStaticUrl(file),
                                  size: "sm",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  class: `m${_vm.$dir.rtl ? "l" : "r"}-2`,
                                  attrs: { icon: "eye" },
                                }),
                                _c("span", { staticClass: "small" }, [
                                  _vm._v(_vm._s(_vm.$t("shared.View"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "b-btn",
                              {
                                class: [
                                  "d-flex align-items-center justify-content-center",
                                  `m${_vm.$dir.rtl ? "r" : "l"}-2`,
                                ],
                                attrs: { variant: "danger", size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(file)
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  class: `m${_vm.$dir.rtl ? "l" : "r"}-2`,
                                  attrs: { icon: "trash" },
                                }),
                                _c("span", { staticClass: "small" }, [
                                  _vm._v(_vm._s(_vm.$t("shared.Remove"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  })
                : !_vm.uploading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex h-100 align-items-center justify-content-center",
                    },
                    [
                      _c(
                        "span",
                        { class: ["text-muted", { small: _vm.size === "sm" }] },
                        [_vm._v(" موردی انتخاب نشده ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.uploading
                ? _c("b-progress", {
                    staticClass: "mb-1",
                    attrs: {
                      variant: "success",
                      value: _vm.progress,
                      "show-progress": "",
                      animated: "",
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            ref: "brb-uploader-file-input",
            attrs: {
              accept: _vm.accept,
              disabled: _vm.inputDisabled,
              multiple: _vm.multiple,
              type: "file",
            },
            on: { change: _vm.onInputChange },
          }),
        ]
      ),
      !_vm.noError && _vm.error && typeof _vm.error === "string"
        ? _c(
            "span",
            { staticClass: "d-block text-right text-danger small mt-2" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm.interlanErrors && _vm.interlanErrors.length
        ? [
            _c(
              "ul",
              { staticClass: "pr-3 mt-2" },
              _vm._l(_vm.interlanErrors, function (error) {
                return _c(
                  "li",
                  { key: error, staticClass: "small text-danger" },
                  [_vm._v(" " + _vm._s(error) + " ")]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }